import { footerColumns } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_repeat(3,1fr)] gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">黑料网社</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/80 max-w-sm">
              黑料网社公共区，是吃瓜大本营，也是老哥开聊的聚集地。讨论群实时开聊，粉丝团蹲新料、跟热评，
              想找同好一起扒细节，长期在线等你。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="#top" aria-label="微信" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-wechat-line" />
              </a>
              <a href="#top" aria-label="微博" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-weibo-line" />
              </a>
              <a href="#top" aria-label="讨论群" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-chat-3-line" />
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-base font-bold text-background-50">
                <a href="#top" className="hover:text-accent-300 transition-colors">{column.title}</a>
              </h4>
              <ul className="mt-5 flex flex-col gap-3">
                {column.items.map((item) => (
                  <li key={item}>
                    <a href="#top" className="text-sm text-background-200/75 hover:text-accent-300 transition-colors whitespace-nowrap">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 pt-7 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/65 text-center sm:text-left">
            © 2026 黑料网社 · 站内内容均为社区网友讨论整理，仅供交流参考
          </p>
          <div className="flex items-center gap-5 text-xs text-background-200/65">
            <a href="#top" className="hover:text-accent-300 transition-colors whitespace-nowrap">社区公约</a>
            <a href="#top" className="hover:text-accent-300 transition-colors whitespace-nowrap">内容说明</a>
            <a href="#top" className="hover:text-accent-300 transition-colors whitespace-nowrap">联系运营</a>
          </div>
        </div>
      </div>
    </footer>
  );
}